import { z } from '@/libs/zod';

export enum CpfRegistrationStatus {
  NotFound = 'not_found',
  Incomplete = 'incomplete',
  Complete = 'complete',
}

export const customerGuestStatusSchema = z.object({
  status: z.nativeEnum(CpfRegistrationStatus),
  hasMail: z.boolean(),
  hasAddress: z.boolean(),
});

export type CustomerGuestStatus = z.infer<typeof customerGuestStatusSchema>;
